module.exports = __webpack_public_path__ + "media/icons/search-a-b2b704d9.png";